import React from 'react';
import Typography from '@material-ui/core/Typography';

function HeadText({ headText, captionText, emailTextContainer }) {
  return (
    <>
      <Typography variant="h5" gutterBottom>
        {headText}
      </Typography>
      <div className={emailTextContainer}>
        <Typography variant="caption">{captionText}</Typography>
      </div>
    </>
  );
}

export default HeadText;
